import { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import LogoFallback from "/assets/img/bubbanlogo.jpg";

const faqs = [
	{
		id: 1,
		question: "What programs does Bandarban University offer?",
		answer:
		  "Bandarban University offers undergraduate and graduate programs across multiple disciplines including science, arts, business, and technology.",
	},
	{
		id: 2,
		question: "How can I apply for admission?",
		answer:
		  "You can apply online through our admission portal or visit the university admission office for in-person guidance.",
	},
	{
		id: 3,
		question: "Does the university provide accommodation?",
		answer:
		  "Yes, the university provides on-campus hostel facilities for both male and female students.",
	},
	{
		id: 4,
		question: "Where is Bandarban University located?",
		answer:
		  "The university is located in the scenic hills of Bandarban, offering a peaceful and inspiring learning environment.",
	},
	{
		id: 5,
		question: "What are the schools in Bandarban University?",
		answer:
		  "There are three (3) schools in Bandarban University. They are School of Arts, Social Science and Law, School of Business Administration and School of Science , Engineering and Technology.",
	},
	{
		id: 6,
		question: "Which bachelor programs are offered by Bandarban University? ",
		answer:
		  "Bandarban University offers the following bachelor programs: Bachelor of Arts in English, Bachelor of Social Science in Governance and Development Studies(GDS), Bachelor of Business Administration(BBA), Bachelor of Computer Science and Engineering(CSE).",
	},
	{
		id: 7,
		question: "Admission Requirements in Bachelor Program? ",
		answer:
		  "Combined GPA of 5.00 in S.S.C and H.S.C with minimum 2.5 in each or total GPA of 6.00 with minimum GPA of 2.00 either in S.S.C or in H.S.C GCE O- Level in minimum 5 subject with a GPA 2.50 and GCE A- Level in 2 subject with a minimum GPA 2.00. Engineering students must have maths and physics in their H.S.C with at least B grade",
	},
	{
		id: 8,
		question: "Admission Requirements in Master Programs ? ",
		answer:
		  "Anyone having GPA of minimum 2.50 can seek admission to master program of the University.",
	},
	{
		id: 9,
		question: "Which master programs are offered by Bandarban University?? ",
		answer:
		  "Bandarban University offers the following master programs: Master of Business Administration.",
	},
];

export default function FaqPage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "FAQ | Bandarban University",
}) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-700 to-teal-600 text-white py-16 text-center">
        <h1 className="text-4xl font-bold">Frequently Asked Questions</h1>
        <p className="mt-2 text-lg opacity-90">
          Find answers to common queries about admissions, programs, and more.
        </p>
      </section>

      {/* FAQ Section */}
      <section className="max-w-4xl mx-auto py-16 px-6">
        <h2 className="text-2xl font-bold mb-8 text-center">Your Questions Answered</h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow hover:shadow-md transition"
            >
              <button
                className="w-full flex justify-between items-center p-4 text-left font-medium text-gray-800 focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <ChevronDown
                  className={`w-5 h-5 transform transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-4 pb-4 text-gray-600 border-t">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="text-center mt-12">
          <p className="text-gray-700">
            Still have questions?{" "}
            <a
              href="/contact"
              className="text-teal-600 font-semibold hover:underline"
            >
              Contact us
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
